import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  displayName: string;
  photoUrl?: string;
}

interface AuthState {
  user: User | null;
  familyId: string | null;
  isPremium: boolean;
  isLoading: boolean;
  setUser: (user: User | null, familyId: string | null, isPremium?: boolean) => void;
  setFamilyId: (familyId: string | null) => void;
  setIsPremium: (isPremium: boolean) => void;
  setLoading: (isLoading: boolean) => void;
  updateDisplayName: (displayName: string) => void;
  updatePhotoUrl: (photoUrl: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      familyId: null,
      isPremium: false,
      isLoading: true,
      setUser: (user, familyId, isPremium = false) => set({ user, familyId, isPremium }),
      setFamilyId: (familyId) => set({ familyId }),
      setIsPremium: (isPremium) => set({ isPremium }),
      setLoading: (isLoading) => set({ isLoading }),
      updateDisplayName: (displayName) => set((state) => ({
        user: state.user ? { ...state.user, displayName } : null,
      })),
      updatePhotoUrl: (photoUrl) => set((state) => ({
        user: state.user ? { ...state.user, photoUrl: photoUrl || undefined } : null,
      })),
      logout: () => set({ user: null, familyId: null, isPremium: false }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        familyId: state.familyId,
      }),
    }
  )
);
